<div class="title-row">
  <h2 class="title">Cliëntfiche van {{ client.getNaam() }}
    @if (client.getFiche()?.getLaatstGewijzigdeTijdstip(); as laatstGewijzigdeTijdstip) {
      <div class="mat-small laatst-gewijzigde-tijdstip">
        Laatst gewijzigd op {{ laatstGewijzigdeTijdstip | date:'d/MM/yyyy' }}
      </div>
    }
  </h2>
  <a mat-raised-button
     color="accent"
     (click)="onWijzigingMeldenClick()">
    Wijziging melden
  </a>
</div>

@if (client.getFiche()?.getAlgemeneInformatie(); as algemeneInformatie) {
  <mat-card class="client-fiche-onderverdeling algemene-informatie">
    <mat-card-header>
      <mat-card-title>Algemene informatie</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="row">
        @if (algemeneInformatie.getDienstencheques() || algemeneInformatie.getGebruikersnummer()) {
          <mat-card>
            <mat-card-header>
              <mat-card-title>Dienstencheques</mat-card-title>
            </mat-card-header>
            <mat-card-content class="card-content">
              @if (algemeneInformatie.getDienstencheques()) {
                <p
                >{{ algemeneInformatie.getDienstencheques() }}</p>
              }
              @if (algemeneInformatie.getGebruikersnummer(); as gebruikersnummer) {
                <p>Met
                  gebruikersnummer: {{ gebruikersnummer }}</p>
              }
            </mat-card-content>
          </mat-card>
        }
        @if (algemeneInformatie.getGeboortedatumAsDate(); as geboortedatumAsDate) {
          <mat-card>
            <mat-card-header>
              <mat-card-title>Geboortedatum</mat-card-title>
            </mat-card-header>
            <mat-card-content class="card-content">
              <p>{{ geboortedatumAsDate | date:'d/MM/yyyy' }}</p>
            </mat-card-content>
          </mat-card>
        }
      </div>
      <div class="row">
        @if (algemeneInformatie.getMoedertaal(); as moedertaal) {
          <mat-card>
            <mat-card-header>
              <mat-card-title>Moedertaal</mat-card-title>
            </mat-card-header>
            <mat-card-content class="card-content">
              <p>{{ moedertaal }}</p>
            </mat-card-content>
          </mat-card>
        }
        @if (algemeneInformatie.getConversatieTaal(); as conversatieTaal) {
          <mat-card>
            <mat-card-header>
              <mat-card-title>Taal waarin je met cliënt kan praten</mat-card-title>
            </mat-card-header>
            <mat-card-content class="card-content">
              <p>{{ conversatieTaal }}</p>
            </mat-card-content>
          </mat-card>
        }
      </div>
      <div class="row">
        @if (algemeneInformatie.getKeyLock(); as keyLock) {
          <mat-card>
            <mat-card-header>
              <mat-card-title>Key-lock code</mat-card-title>
            </mat-card-header>
            <mat-card-content class="card-content">
              <p>{{ keyLock }}</p>
            </mat-card-content>
          </mat-card>
        }
        @if (algemeneInformatie.getAutoStaanPlaats(); as autoStaanPlaats) {
          <mat-card>
            <mat-card-header>
              <mat-card-title>Autostaanplaats / Parking in de buurt</mat-card-title>
            </mat-card-header>
            <mat-card-content class="card-content">
              <p>{{ autoStaanPlaats }}</p>
            </mat-card-content>
          </mat-card>
        }
      </div>
      @if (algemeneInformatie.getExtraInfoBereikbaarheid(); as extraInfoBereikbaarheid) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Extra info i.v.m. bereikbaarheid</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            <p>{{ extraInfoBereikbaarheid }}</p>
          </mat-card-content>
        </mat-card>
      }
      @if (algemeneInformatie.getInwonendeGezinsleden(); as inwonendeGezinsleden) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Inwonende gezinsleden</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            <p>{{ inwonendeGezinsleden }}</p>
          </mat-card-content>
        </mat-card>
      }
      @if (algemeneInformatie.getSocialeSituatieSchets(); as socialeSituatieSchets) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Korte sociale situatieschets</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            <p>{{ socialeSituatieSchets }}</p>
          </mat-card-content>
        </mat-card>
      }
      @if (algemeneInformatie.getExtraInformatie(); as extraInformatie) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Extra informatie/aandachtspunten</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            <p>{{ extraInformatie }}</p>
          </mat-card-content>
        </mat-card>
      }
    </mat-card-content>
  </mat-card>
}

@if (client.getFiche()?.getTakenpakket(); as takenPakket) {
  <mat-card class="client-fiche-onderverdeling takenpakket">
    <mat-card-header>
      <mat-card-title>Takenpakket binnen Zorg Leuven</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      @if (takenPakket.getRedenOpstart(); as redenOpstart) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Reden van opstart</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            <p>{{ redenOpstart }}</p>
          </mat-card-content>
        </mat-card>
      }
      @if (takenPakket.getTeBehalenDoelstellingen(); as teBehalenDoelstellingen) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Te behalen doelstellingen</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            <p>{{ teBehalenDoelstellingen }}</p>
          </mat-card-content>
        </mat-card>
      }
      @if (takenPakket.getPoetsdienst(); as poetsDienst) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Poetsdienst</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            @if (poetsDienst.getStatus(); as status) {
              <p>{{ status }}</p>
            }
            @if (poetsDienst.getFrequentie(); as frequentie) {
              <p>{{ frequentie }}</p>
            }
            @if (poetsDienst.getVasteMedewerkers(); as poetsdienstVasteMedewerkers) {
              <div class="content-subdivision">Vaste huishoudhulpen:</div>
              <p>{{ poetsdienstVasteMedewerkers }}</p>
            }
            @if (poetsDienst.getBelangrijksteTaken(); as poetsdienstBelangrijksteTaken) {
              <div class="content-subdivision">Belangrijkste taken:</div>
              <p>{{ poetsdienstBelangrijksteTaken }}</p>
            }
          </mat-card-content>
        </mat-card>
      }
      @if (takenPakket.getGezinszorg(); as gezinszorg) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Gezinszorg</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            @if (gezinszorg.getStatus(); as status) {
              <p>{{ status }}</p>
            }
            @if (gezinszorg.getFrequentie(); as frequentie) {
              <p>{{ frequentie }}</p>
            }
            @if (gezinszorg.getVasteMedewerkers(); as gezinszorgVasteMedewerkers) {
              <div class="content-subdivision">Vaste verzorgenden:</div>
              <p>{{ gezinszorgVasteMedewerkers }}</p>
            }
            @if (gezinszorg.getBelangrijksteTaken(); as gezinszorgBelangrijksteTaken) {
              <div class="content-subdivision">Belangrijkste taken:</div>
              <p>{{ gezinszorgBelangrijksteTaken }}</p>
            }
            @if (gezinszorg.getSpecifiekeInformatieVoorWeekend(); as gezinszorgSpecifiekeInformatieVoorWeekend) {
              <div class="content-subdivision">Specifieke informatie voor het weekend:</div>
              <p>{{ gezinszorgSpecifiekeInformatieVoorWeekend }}</p>
            }
          </mat-card-content>
        </mat-card>
      }
      @if (takenPakket.getMaaltijdenAanHuis(); as maaltijdenAanHuis) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Maaltijden aan huis</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            @if (maaltijdenAanHuis.getStatus(); as status) {
              <p>{{ status }}</p>
            }
            @if (maaltijdenAanHuis.getFrequentie(); as frequentie) {
              <p>{{ frequentie }}</p>
            }
            @if (maaltijdenAanHuis.getBelangrijksteTaken(); as belangrijksteTaken) {
              <div
                class="content-subdivision">Belangrijkste taken:
              </div>
              <p>{{ belangrijksteTaken }}</p>
            }
          </mat-card-content>
        </mat-card>
      }
      @if (takenPakket.getKlusjesdienst(); as klusjesdienst) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Klusjesdienst</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            @if (klusjesdienst.getStatus(); as status) {
              <p>{{ status }}</p>
            }
            @if (klusjesdienst.getFrequentie(); as frequentie) {
              <p>{{ frequentie }}</p>
            }
            @if (klusjesdienst.getBelangrijksteTaken(); as belangrijksteTaken) {
              <div
                class="content-subdivision">Belangrijkste taken:
              </div>
              <p>{{ belangrijksteTaken }}</p>
            }
          </mat-card-content>
        </mat-card>
      }
      @if (takenPakket.getPsycholoog(); as psycholoog) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Eerstelijnspsycholoog</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            @if (psycholoog.getStatus(); as status) {
              <p>{{ status }}</p>
            }
            @if (psycholoog.getFrequentie(); as frequentie) {
              <p>{{ frequentie }}</p>
            }
            @if (psycholoog.getBelangrijksteTaken(); as belangrijksteTaken) {
              <div
                class="content-subdivision">Belangrijkste taken:
              </div>
              <p>{{ belangrijksteTaken }}</p>
            }
          </mat-card-content>
        </mat-card>
      }
      @if (takenPakket.getErgotherapeut(); as ergotherapeut) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Ergotherapeut</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            @if (ergotherapeut.getStatus(); as status) {
              <p>{{ status }}</p>
            }
            @if (ergotherapeut.getFrequentie(); as frequentie) {
              <p>{{ frequentie }}</p>
            }
            @if (ergotherapeut.getBelangrijksteTaken(); as belangrijksteTaken) {
              <div
                class="content-subdivision">Belangrijkste taken:
              </div>
              <p>{{ belangrijksteTaken }}</p>
            }
          </mat-card-content>
        </mat-card>
      }
      @if (takenPakket.getMantelzorgcoordinator(); as mantelzorgcoordinator) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Mantelzorgcoördinator</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            @if (mantelzorgcoordinator.getStatus(); as status) {
              <p>{{ status }}</p>
            }
            @if (mantelzorgcoordinator.getFrequentie(); as frequentie) {
              <p>{{ frequentie }}</p>
            }
            @if (mantelzorgcoordinator.getBelangrijksteTaken(); as belangrijksteTaken) {
              <div
                class="content-subdivision">Belangrijkste taken:
              </div>
              <p>{{ belangrijksteTaken }}</p>
            }
          </mat-card-content>
        </mat-card>
      }
      @if (takenPakket.getCasemanager(); as casemanager) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Casemanager</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            @if (casemanager.getStatus(); as status) {
              <p>{{ status }}</p>
            }
            @if (casemanager.getFrequentie(); as frequentie) {
              <p>{{ frequentie }}</p>
            }
            @if (casemanager.getBelangrijksteTaken(); as belangrijksteTaken) {
              <div
                class="content-subdivision">Belangrijkste taken:
              </div>
              <p>{{ belangrijksteTaken }}</p>
            }
          </mat-card-content>
        </mat-card>
      }
      @if (takenPakket.getCasaClementina(); as casaClementina) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Casa Clementina</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            @if (casaClementina.getContactpersoonNoodgeval(); as contactpersoonNoodgeval) {
              <div class="content-subdivision">Contactpersoon in noodgeval:</div>
              <p>
                <span class="display-block hide-if-empty">{{ contactpersoonNoodgeval?.getNaam() }}</span>
                <span
                  class="display-block hide-if-empty">{{ contactpersoonNoodgeval?.getRelatieTotHulpvrager() }}</span>
                <span class="display-block hide-if-empty">{{ contactpersoonNoodgeval?.getTelefoonnummer() }}</span>
              </p>
            }
            @if (casaClementina.getAandachtspuntenEnGemaakteAfspraken(); as aandachtspuntenEnGemaakteAfspraken) {
              <div
                class="content-subdivision">Aandachtspunten en gemaakte afspraken:
              </div>
              <p>{{ aandachtspuntenEnGemaakteAfspraken }}</p>
            }
            @if (casaClementina.getTransportOptiesNaarCasaClementina()?.length > 0) {
              <div class="content-subdivision">Hoe geraakt cliënt in Casa Clementina:</div>
              <p>
                @for (transportOptie of casaClementina.getTransportOptiesNaarCasaClementina(); track transportOptie) {
                  - {{ transportOptie }}<br>
                }
              </p>
            }
            @if (casaClementina.getVerduidelijkingAndereTransportOptieNaarCasaClementina(); as verduidelijkingAndereTransportOptieNaarCasaClementina) {
              <div class="content-subdivision">Verduidelijking andere:</div>
              <p>{{ verduidelijkingAndereTransportOptieNaarCasaClementina }}</p>
            }
            @if (casaClementina.getFinancieleOpties()?.length > 0) {
              <div class="content-subdivision">Financieel:</div>
              <p>
                @for (financieelOptie of casaClementina.getFinancieleOpties(); track financieelOptie) {
                  - {{ financieelOptie }}<br>
                }
              </p>
            }
          </mat-card-content>
        </mat-card>
      }
      @if (takenPakket.hasWaarTeVindenInformation()) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Waar te vinden</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            @if (takenPakket.getStofzuigerWaarTeVinden(); as stofzuigerWaarTeVinden) {
              <div class="content-subdivision">
                Stofzuiger:
              </div>
              <p>{{ stofzuigerWaarTeVinden }}</p>
            }
            @if (takenPakket.getPoetsproductenWaarTeVinden(); as poetsproductenWaarTeVinden) {
              <div class="content-subdivision">
                Poetsproducten:
              </div>
              <p>{{ poetsproductenWaarTeVinden }}</p>
            }
            @if (takenPakket.getDoekenVoddenDweilenWaarTeVinden(); as doekenVoddenDweilenWaarTeVinden) {
              <div
                class="content-subdivision">Doeken/vodden/dweilen:
              </div>
              <p>{{ doekenVoddenDweilenWaarTeVinden }}</p>
            }
            @if (takenPakket.getTelescopischeSteelWaarTeVinden(); as telescopischeSteelWaarTeVinden) {
              <div
                class="content-subdivision">Telescopische steel:
              </div>
              <p>{{ telescopischeSteelWaarTeVinden }}</p>
            }
            @if (takenPakket.getAndereWaarTeVinden(); as andereWaarTeVinden) {
              <div class="content-subdivision">Ander
                poetsmateriaal:
              </div>
              <p>{{ andereWaarTeVinden }}</p>
            }
          </mat-card-content>
        </mat-card>
      }
      @if (takenPakket.getAandachtspuntenPoetsen(); as aandachtspuntenPoetsen) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Aandachtspunten bij het poetsen</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            <p>{{ aandachtspuntenPoetsen }}</p>
          </mat-card-content>
        </mat-card>
      }
      @if (takenPakket.getAandachtspuntenAndereTaken(); as aandachtspuntenAndereTaken) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Aandachtspunten bij andere taken</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            <p>{{ aandachtspuntenAndereTaken }}</p>
          </mat-card-content>
        </mat-card>
      }
    </mat-card-content>
  </mat-card>
}

@if (client.getFiche()?.getKnelpunten(); as knelpunten) {
  <mat-card class="client-fiche-onderverdeling knelpunten">
    <mat-card-header>
      <mat-card-title>Knelpunten</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      @if (knelpunten.getAllergieen(); as allergieen) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Allergieën</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            <p>{{ allergieen }}</p>
          </mat-card-content>
        </mat-card>
      }
      @if (knelpunten.getHuisdieren(); as huisdieren) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Huisdieren</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            <p>{{ huisdieren }}</p>
          </mat-card-content>
        </mat-card>
      }
      @if (knelpunten.getRoken(); as roken) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Roken</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            <p>{{ roken }}</p>
          </mat-card-content>
        </mat-card>
      }
    </mat-card-content>
  </mat-card>
}

@if (client.getFiche()?.getMogelijkeProblematieken(); as mogelijkeProblematieken) {
  <mat-card class="client-fiche-onderverdeling mogelijke-problematieken"
  >
    <mat-card-header>
      <mat-card-title>Mogelijke problematieken</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      @if (mogelijkeProblematieken.getFysiek(); as fysiek) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Fysiek</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            <p>{{ fysiek }}</p>
          </mat-card-content>
        </mat-card>
      }
      @if (mogelijkeProblematieken.getMentaal(); as mentaal) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Mentaal</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            <p>{{ mentaal }}</p>
          </mat-card-content>
        </mat-card>
      }
      @if (mogelijkeProblematieken.getHandvatenOmMetClientOmTeGaan(); as handvatenOmMetClientOmTeGaan) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Indien psy-cliënt: handvaten om met deze cliënt om te gaan</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            <p>{{ handvatenOmMetClientOmTeGaan }}</p>
          </mat-card-content>
        </mat-card>
      }
      @if (mogelijkeProblematieken.getFinancieel(); as financieel) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Financieel</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            <p>{{ financieel }}</p>
          </mat-card-content>
        </mat-card>
      }
      @if (mogelijkeProblematieken.getAndere(); as andere) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Andere problematieken</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            <p>{{ andere }}</p>
          </mat-card-content>
        </mat-card>
      }
      @if (mogelijkeProblematieken.getAfsprakennota(); as afsprakennota) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>Afsprakennota – korte samenvatting</mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            <p>{{ afsprakennota }}</p>
          </mat-card-content>
        </mat-card>
      }
    </mat-card-content>
  </mat-card>
}

@if (client.getFiche()?.hasAndereDiensten()) {
  <mat-card class="client-fiche-onderverdeling andere-diensten">
    <mat-card-header>
      <mat-card-title>Andere diensten</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      @for (andereDienst of andereDiensten; track andereDienst) {
        <mat-card>
          <mat-card-header>
            <mat-card-title>
              <span
                [ngClass]="{'display-italic': !andereDienst.getFunctie()}">{{ andereDienst.getFunctie() || "functie niet ingevuld" }}</span>
              - <span
              [ngClass]="{'display-italic': !andereDienst.getNaamDienstverlenerOfOrganisatie()}">{{ andereDienst.getNaamDienstverlenerOfOrganisatie() || "naam niet ingevuld" }}</span>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content class="card-content">
            <p>{{ andereDienst.getExtraInfo() }}</p>
          </mat-card-content>
        </mat-card>
      }
    </mat-card-content>
  </mat-card>
}

@if (!client.hasFiche()) {
  <div class="no-client-fiche-content">
    Geen cliëntfiche ingevuld voor deze client, contacteer jouw dienst
  </div>
}

<button mat-mini-fab
        color="primary"
        class="back-button"
        (click)="onBackButtonClicked()">
  <mat-icon>arrow_back</mat-icon>
</button>
